export * from './setup-details.component';
